import styleInject from '../../../../external_node_modules/style-inject/dist/style-inject.es.js';

var css_248z = ".popup-footer.wcl-frqp1j{display:flex;justify-content:center;padding:15px;box-sizing:border-box;border-top:1px solid rgba(255, 255, 255, 0.3)}";
styleInject(css_248z);

export { css_248z as default };
//# sourceMappingURL=PopupFooter.css.js.map
